import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Skeleton } from '@/components/ui/skeleton';
import ThreadItemSkeleton from './ThreadItemSkeleton';
import GradientAnimationStyles from './GradientAnimationStyles';

interface ThreadsListSkeletonProps {
  itemCount?: number;
}

const ThreadsListSkeleton: React.FC<ThreadsListSkeletonProps> = ({ 
  itemCount = 5 
}) => {
  return (
    <div className="h-full flex flex-col">
      {/* Create Thread Button Skeleton */}
      <div className="flex-none px-2 mb-2">
        <Skeleton className="h-12 w-full rounded-md" />
      </div>
      
      {/* Scrollable Content Skeleton */}
      <div className="flex-1 min-h-0">
        <ScrollArea className="h-full w-full" orientation="vertical">
          <div className="h-full pb-2 space-y-3">
            {Array.from({ length: itemCount }).map((_, i) => (
              <ThreadItemSkeleton key={`thread-skeleton-${i}`} index={i} />
            ))}
          </div>
        </ScrollArea>
      </div>
      
      {/* Gradient Animation Styles */}
      <GradientAnimationStyles />
    </div>
  );
};

export default ThreadsListSkeleton;
